import React from 'react';
import PartnerCatalogPage from './PartnerCatalogPage';

const PartnerAddOns = () => <PartnerCatalogPage kind="addon" />;

export default PartnerAddOns;
